
import IconifyIcon from '@iconify/vue'

import roundMail from '@iconify/icons-ic/round-mail'
import shieldLockFill from '@iconify/icons-bi/shield-lock-fill'

export const Iconify = IconifyIcon

export const email = roundMail
export const lock = shieldLockFill